module.exports = __webpack_public_path__ + "img/cart.b67823a0.svg";